module.exports = __webpack_public_path__ + "static/approved_rejected@3x.4a62ea08.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/membership/approved_rejected@3x.png
// module id = 715
// module chunks = 92562407457355